import { FC, useEffect, useState } from 'react';

import BlockDeviceSuccess from './components/BlockDeviceSuccess';
import ConfirmBlockDevice from './components/ConfirmBlockDevice';
import ConfirmUnblockDevice from './components/ConfirmUnblockDevice';
import DeviceDetails from './components/DeviceDetails';
import UnblockDeviceSuccess from './components/UnblockDeviceSuccess';
import { Props, Step } from './types';

const DeviceSidebar: FC<Props> = ({ device, setSelectedDevice }) => {
  const [step, setStep] = useState<Step>(Step.VIEW);

  const closeSidebar = () => {
    setStep(Step.VIEW);
    setSelectedDevice(null);
  };

  useEffect(() => {
    setStep(Step.VIEW);
  }, [device.authenticationDeviceId]);

  return (
    <>
      {step === Step.VIEW ? (
        <DeviceDetails close={closeSidebar} device={device} setStep={setStep} />
      ) : null}

      {[Step.BLOCK, Step.BLOCK_SUCCESS].includes(step) ? (
        <ConfirmBlockDevice
          close={closeSidebar}
          device={device}
          next={() => setStep(Step.BLOCK_SUCCESS)}
          previous={() => setStep(Step.VIEW)}
        />
      ) : null}

      {[Step.UNBLOCK, Step.UNBLOCK_SUCCESS].includes(step) ? (
        <ConfirmUnblockDevice
          close={closeSidebar}
          device={device}
          next={() => setStep(Step.UNBLOCK_SUCCESS)}
          previous={() => setStep(Step.VIEW)}
        />
      ) : null}

      {step === Step.BLOCK_SUCCESS ? (
        <BlockDeviceSuccess close={closeSidebar} />
      ) : null}

      {step === Step.UNBLOCK_SUCCESS ? (
        <UnblockDeviceSuccess close={closeSidebar} device={device} />
      ) : null}
    </>
  );
};

export default DeviceSidebar;
